module.exports = __webpack_public_path__ + "static/greens-acorn-e237da5ef3daff654d5ccd246bdfb2cf.webm";